import { cva } from '@/styled-system/css';

export const inputChipRootRecipe = cva({
  base: {
    'display': 'inline-flex',
    'alignItems': 'center',
    'verticalAlign': 'top',
    'borderRadius': 'shape.capsule',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
    'boxShadowColor': { base: 'border.action.hero.selected.default' },
    'paddingInlineStart': 'Chip.padding.horz',
    'backgroundColor': { base: 'bg.action.soft.selected.default' },

    '&:not(:has([data-c11n-component="InputChip.Close"]))': {
      paddingInlineEnd: 'Chip.padding.horz',
    },

    // Enables the flex child (InputChipLabel) to shrink and truncate
    'minWidth': '0',
  },
  variants: {
    elevated: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      elevated: true,
      disabled: false,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.sm}',
          _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  ],
});
